import React from "react";
import LazyImage from "ui/LazyImage/LazyImage";
import styles from "./YandexWidgetReviews.module.scss";

const YandexWidgetReviews = () => (
  <a
    className={styles.container}
    rel="nofollow"
    href="https://market.yandex.ru/business--zdravsiti-servis-zakaza-i-vydachi-lekarstv/919242/reviews"
  >
    <LazyImage
      className={styles.containerImageContainer}
      width="140"
      height="28"
      src="/img/footer/yandex-market.png"
      alt="yandex market"
    />
    <LazyImage
      className={styles.containerImageContainer}
      width="140"
      height="22"
      src="/img/footer/yandex-stars.png"
      alt="yandex stars"
    />
  </a>
);

export default YandexWidgetReviews;
